import gradient from './gradient';

export default function(context, item, value) {
  return (value.id) ?
    gradient(context, value, item.bounds) :
    value;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/util/canvas/color.js
// module id = 447
// module chunks = 0